import { createStore } from 'zustand';
var createStateStore = function (initial) {
    return createStore()(function (set) { return ({
        key: initial !== null && initial !== void 0 ? initial : null,
        setKey: function (key) {
            set(function () { return ({ key: key }); });
        },
    }); });
};
var defaultStores = new Map();
var createStateStoreFactory = function (stores) {
    return function (storeKey, initialKey) {
        if (!stores.has(storeKey)) {
            stores.set(storeKey, createStateStore(initialKey));
        }
        return stores.get(storeKey);
    };
};
export var getOrCreateStoreByKey = createStateStoreFactory(defaultStores);
